import ManualActionIncentivationSourceEditor from "../../../pages/actionModules/ActionModuleEditor/IncentivationSourceEditor/ManualActionIncentivationSourceEditor";
import { IncentivationSourceDefinition } from "../actionModule";
import { IncentivationSourceEditorProps } from "../editor/incentivationSourceEditorTypes";
import { ManualActionIncentivationSourceModel, IncentivationSourceType } from "./incentivationSourceModel";


export const ManualActionIncentivationSource: IncentivationSourceDefinition = {
    name: "actionModules.incentivationSource.manualAction.name",
    defaultValue: {
        canBeCompletedByEmployeeUser: true,
        canBulkUploadIncentivationData: false,
    } as ManualActionIncentivationSourceModel,
    editor: (props: IncentivationSourceEditorProps) => <ManualActionIncentivationSourceEditor {...props} />,
    type: IncentivationSourceType.ManualActionIncentivationSource,
};